export default __webpack_public_path__ + "static/media/default-profile-avatar.a9136072.png";